import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useWealthSavingsHowToGetStartedContent } from '../../../../hooks/useWealthSavingsHowToGetStartedContent';
import './HowToGetStarted.css';

const HowToGetStarted = () => {
  const { content, isLoading } = useWealthSavingsHowToGetStartedContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, steps } = content;

  return (
    <section className="how-to-get-started">
      <div className="how-to-get-started__inner">
        <Reveal>
          <h2 className="how-to-get-started__title">{title}</h2>
        </Reveal>

        <div className="how-to-get-started__steps">
          {steps.map(({ number, title: stepTitle, description }, index) => (
            <Reveal
              key={`${stepTitle}-${index}`}
              delay={index * 80}
              className="how-to-get-started__step"
            >
              <p className="how-to-get-started__number">{number}</p>
              <h3 className="how-to-get-started__step-title">{stepTitle}</h3>
              <p className="how-to-get-started__step-text">{description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToGetStarted;
